import { ENDPOINTS } from "@/api/application-api";
import { useUserToken } from "@/context/auth-context";
import { Pagination } from "@/types";
import { WorkspaceInvite } from "@/types/workspace-invite";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

interface WorkspaceInviteIn {
  workspace_id: number;
  emails: Array<string>;
}

const useCreateWorkspaceInvite = () => {
  const userToken = useUserToken();
  const queryClient = useQueryClient();
  return useMutation(
    (body: WorkspaceInviteIn) =>
      fetch(ENDPOINTS.workspace_invites, {
        method: "POST",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify(body),
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ENDPOINTS.workspace_invites]);
      },
    },
  );
};

const useWorkspaceInvites = () => {
  const userToken = useUserToken();
  return useQuery(
    [ENDPOINTS.workspace_invites],
    (): Promise<Pagination<WorkspaceInvite>> =>
      fetch(ENDPOINTS.workspace_invites, {
        headers: jsonAuthHeaders(userToken),
      }).then(handleResponse),
  );
};

export { useCreateWorkspaceInvite, useWorkspaceInvites, WorkspaceInviteIn };
